// MUI v8 compatible theme file
// Converted from your MUI v6 theme without changing your values

import React from 'react'
import { createTheme } from '@mui/material/styles'

// === MODULE AUGMENTATION (MUI v8 format remains the same) ===
declare module '@mui/material/styles' {
  interface TypographyVariants {
    h1DMSans: React.CSSProperties
    h1DMSansBold: React.CSSProperties
    h2DMSans: React.CSSProperties
    h2DMSansBold: React.CSSProperties
    h3DMSans: React.CSSProperties
    h3DMSansBold: React.CSSProperties
    h4DMSans: React.CSSProperties
    h4DMSansBold: React.CSSProperties
    h5DMSans: React.CSSProperties
    h5DMSansBold: React.CSSProperties
    h6DMSans: React.CSSProperties
    body2DMSans: React.CSSProperties
    body2DMSansBold: React.CSSProperties
    DmSanssectionSubHeading: React.CSSProperties
    DmSanssectionHeading: React.CSSProperties
    h1VagLarge: React.CSSProperties
    h1VagBold: React.CSSProperties
    h2VagBold: React.CSSProperties
    h2Vag: React.CSSProperties
    h3Vag: React.CSSProperties
    h3VagBold: React.CSSProperties
    h4Vag: React.CSSProperties
    h4VagBold: React.CSSProperties
    h5Vag: React.CSSProperties
    h5VagBold: React.CSSProperties
    h6VagBold: React.CSSProperties
    h6Vag: React.CSSProperties
    descriptionVagBold: React.CSSProperties
    body2Vag: React.CSSProperties
    navBarVag: React.CSSProperties
    body: React.CSSProperties
    sideBarVag: React.CSSProperties
    RobotoInnerText: React.CSSProperties
    DMSansHeaderSecondary: React.CSSProperties
    RobotoHeaderPrimary: React.CSSProperties
    RobotoHeaderSecondary: React.CSSProperties
    DmSansTableHeading: React.CSSProperties
    RobotoTableBody: React.CSSProperties
    RobotoBody: React.CSSProperties
    RobotoGraphHeader: React.CSSProperties
    AccordianHeaderDMSans: React.CSSProperties
    AccordianHeaderRoboto: React.CSSProperties
    TableCellRoboto: React.CSSProperties
    TableHeaderRoboto: React.CSSProperties
    TableCellError: React.CSSProperties
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    h1DMSans?: React.CSSProperties
    h1DMSansBold?: React.CSSProperties
    h2DMSans?: React.CSSProperties
    h2DMSansBold?: React.CSSProperties
    h3DMSans?: React.CSSProperties
    h3DMSansBold?: React.CSSProperties
    h4DMSans?: React.CSSProperties
    h4DMSansBold?: React.CSSProperties
    h5DMSans?: React.CSSProperties
    h5DMSansBold?: React.CSSProperties
    h6DMSans?: React.CSSProperties
    body2DMSans?: React.CSSProperties
    body2DMSansBold?: React.CSSProperties
    DmSanssectionSubHeading?: React.CSSProperties
    DmSanssectionHeading?: React.CSSProperties
    h1VagLarge?: React.CSSProperties
    h1VagBold?: React.CSSProperties
    h2VagBold?: React.CSSProperties
    h2Vag?: React.CSSProperties
    h3Vag?: React.CSSProperties
    h3VagBold?: React.CSSProperties
    h4Vag?: React.CSSProperties
    h4VagBold?: React.CSSProperties
    h5Vag?: React.CSSProperties
    h5VagBold?: React.CSSProperties
    h6VagBold?: React.CSSProperties
    h6Vag?: React.CSSProperties
    descriptionVagBold?: React.CSSProperties
    body2Vag?: React.CSSProperties
    navBarVag?: React.CSSProperties
    body?: React.CSSProperties
    sideBarVag?: React.CSSProperties
    RobotoInnerText?: React.CSSProperties
    DMSansHeaderSecondary?: React.CSSProperties
    RobotoHeaderPrimary?: React.CSSProperties
    RobotoHeaderSecondary?: React.CSSProperties
    DmSansTableHeading?: React.CSSProperties
    RobotoTableBody?: React.CSSProperties
    RobotoBody?: React.CSSProperties
    RobotoGraphHeader?: React.CSSProperties
    AccordianHeaderDMSans?: React.CSSProperties
    AccordianHeaderRoboto?: React.CSSProperties
    TableCellRoboto?: React.CSSProperties
    TableHeaderRoboto?: React.CSSProperties
    TableCellError?: React.CSSProperties
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    h1DMSans: true
    h1DMSansBold: true
    h2DMSans: true
    h2DMSansBold: true
    h3DMSans: true
    h3DMSansBold: true
    h4DMSans: true
    h4DMSansBold: true
    h5DMSans: true
    h5DMSansBold: true
    h6DMSans: true
    body2DMSans: true
    body2DMSansBold: true
    DmSanssectionSubHeading: true
    DmSanssectionHeading: true
    h1VagLarge: true
    h1VagBold: true
    h2VagBold: true
    h2Vag: true
    h3Vag: true
    h3VagBold: true
    h4Vag: true
    h4VagBold: true
    h5Vag: true
    h5VagBold: true
    h6VagBold: true
    h6Vag: true
    descriptionVagBold: true
    body2Vag: true
    navBarVag: true
    body: true
    sideBarVag: true
    RobotoInnerText: true
    DMSansHeaderSecondary: true
    RobotoHeaderPrimary: true
    RobotoHeaderSecondary: true
    DmSansTableHeading: true
    RobotoTableBody: true
    RobotoBody: true
    RobotoGraphHeader: true
    AccordianHeaderDMSans: true
    AccordianHeaderRoboto: true
    TableCellRoboto: true
    TableHeaderRoboto: true
    TableCellError: true
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    primary: true;
  }
}

// === MAIN THEME (converted to MUI v8) ===
export const theme = createTheme({
  typography: {
    h1DMSans: {
      fontWeight: 200,
      fontFamily: 'DMSansRegular',
      fontSize: '40px',
      lineHeight: '52.08px',
    },
    h1DMSansBold: {
      fontWeight: 700,
      fontFamily: 'DMSansBold',
      fontSize: '40px',
      lineHeight: '52.08px',
    },
    h2DMSans: {
      fontWeight: 400,
      fontFamily: 'DMSansRegular',
      fontSize: '32px',
      lineHeight: '41.66px',
    },
    h2DMSansBold: {
      fontWeight: 900,
      fontFamily: 'DMSansBold',
      fontSize: '32px',
      lineHeight: '41.66px',
    },
    h3DMSans: {
      fontFamily: 'DMSansRegular',
      fontWeight: 600,
      fontSize: '50px',
    },
    h3DMSansBold: {
      fontFamily: 'DMSansBold',
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '31.25px',
    },
    h4DMSans: {
      fontFamily: 'DMSansRegular',
      fontWeight: 600,
      fontSize: '40px',
    },
    h4DMSansBold: {
      fontFamily: 'DMSansBold',
      fontWeight: 800,
      fontSize: '40px',
    },
    h5DMSans: {
      fontFamily: 'DMSansRegular',
      fontWeight: 600,
      fontSize: '24px',
    },
    h5DMSansBold: {
      fontWeight: 900,
      fontFamily: 'DMSansBold',
      fontSize: '2.5em',
      lineHeight: '1.15em',
    },
    h6DMSans: {
      fontFamily: 'DMSansRegular',
      fontWeight: 900,
      fontSize: '1.2em',
    },
    body2DMSans: {
      fontFamily: 'DMSansRegular',
      fontSize: '14px',
      fontWeight: 600,
    },
    body2DMSansBold: {
      fontFamily: 'DMSansBold',
      fontSize: '16px',
      fontWeight: 400,
    },
    DmSanssectionSubHeading: {
      fontFamily: 'DMSansRegular',
      fontWeight: 500,
      fontSize: '13px',
      color: '#505050',
    },
    DmSanssectionHeading: {
      fontFamily: 'DMSansRegular',
      fontWeight: 600,
      fontSize: 20,
      color: '#1B2064',
    },
    DmSansTableHeading: {
      fontFamily: 'DMSansBold',
      fontWeight: 500,
      fontSize: 18,
    },
    h1Vag: {
      fontWeight: 200,
      fontFamily: 'DMSansRegular',
      fontSize: '3.3125rem',
      lineHeight: '1.15em',
    },
    h1VagLarge: {
      fontWeight: 200,
      fontFamily: 'DMSansRegular',
      fontSize: '90px',
      lineHeight: '1.15em',
    },
    h1VagBold: {
      fontWeight: 900,
      fontFamily: 'DMSansRegular',
      fontSize: '3.3125rem',
      lineHeight: '1.15em',
    },
    h2Vag: {
      fontWeight: 400,
      fontFamily: 'DMSansRegular',
      fontSize: '60px',
      lineHeight: '1.05em',
    },
    h2VagBold: {
      fontWeight: 900,
      fontFamily: 'DMSansRegular',
      fontSize: '60px',
      lineHeight: '1.15em',
    },
    h3Vag: {
      fontFamily: 'DMSansRegular',
      fontWeight: 600,
      fontSize: '50px',
    },
    h3VagBold: {
      fontFamily: 'DMSansRegular',
      fontWeight: 800,
      fontSize: '50px',
    },
    h4Vag: {
      fontFamily: 'DMSansRegular',
      fontWeight: 600,
      fontSize: '40px',
    },
    h4VagBold: {
      fontFamily: 'DMSansRegular',
      fontWeight: 800,
      fontSize: '40px',
    },
    h5Vag: {
      fontFamily: 'DMSansRegular',
      fontWeight: 600,
      fontSize: '24px',
    },
    h5VagBold: {
      fontWeight: 700,
      fontFamily: 'DMSansRegular',
      fontSize: '2.0em',
      lineHeight: '1.15em',
    },
    h6Vag: {
      fontFamily: 'DMSansRegular',
      fontWeight: 900,
      fontSize: '1.2em',
    },
    h6VagBold: {
      fontFamily: 'DMSansRegular',
      fontWeight: 400,
      fontSize: '1.75em',
    },
    navBarVag: {
      fontFamily: 'DMSansRegular',
      fontWeight: 400,
      fontSize: '1.95em',
    },
    descriptionVagBold: {
      fontFamily: 'DMSansRegular',
      fontWeight: 300,
      fontSize: '1.5em',
    },
    body2Vag: {
      fontFamily: 'DMSansRegular',
      fontSize: '16px',
      fontWeight: 100,
      color: 'white',
    },
    sideBarVag: {
      fontFamily: 'DMSansRegular',
      fontSize: '18px',
      fontWeight: 200,
    },
    body: {
      fontFamily: 'DMSansRegular',
      fontWeight: 100,
      fontSize: '1em',
    },
    RobotoBody: {
      fontFamily: 'RobotoRegular',
      fontWeight: 400,
      fontSize: '16px',
    },
    RobotoInnerText: {
      fontFamily: 'RobotoRegular',
      fontWeight: 100,
      fontSize: '0.85em',
    },
    DMSansHeaderSecondary: {
      fontFamily: 'DMSansBold',
      fontWeight: 700,
      fontSize: '24px',
      color: '#737373',
    },
    RobotoHeaderPrimary: {
      fontFamily: 'RobotoBold',
      fontWeight: 700,
      color: '#1B2064',
      fontSize: '40px',
    },
    RobotoGraphHeader: {
      fontFamily: 'RobotoBold',
      fontWeight: 500,
      fontSize: '20px',
    },
    RobotoHeaderSecondary: {
      fontFamily: 'RobotoBold',
      fontWeight: 700,
      color: '#737373',
      fontSize: '24px',
    },
    RobotoTableBody: {
      fontFamily: 'RobotoRegular',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '18.75px',
    },
    AccordianHeaderDMSans: {
      fontSize: 23,
      color: '#1B2559',
      fontFamily: 'DMSansBold',
      fontWeight: 400,
    },
    AccordianHeaderRoboto: {
      fontSize: 23,
      color: '#1B2559',
      fontFamily: 'RobotoBold',
      fontWeight: 400,
    },
    TableHeaderRoboto: {
      fontFamily: 'RobotoBold',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '19.2px',
      color: 'black',
    },
    TableCellRoboto: {
      fontFamily: 'RobotoRegular',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '19.2px',
      color: 'black',
    },
    TableCellError: {
      fontFamily: 'RobotoRegular',
      fontWeight: 500,
      fontSize: '12px',
      color: '#d32f2f',
      display: 'block',
    },
  },

  components: {
    MuiMenu: {
      defaultProps: {
        disableScrollLock: false,
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          background: 'linear-gradient(180deg, #06205D 0%, #111737 100%)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input.Mui-disabled': {
            color: '#36454F',
            WebkitTextFillColor: '#36454F',
            cursor: 'not-allowed',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: 'transparent !important',
            color: 'darkgray !important',
            opacity: 1,
            cursor: 'not-allowed',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
          '&.Mui-disabled': {
            cursor: 'not-allowed',
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        dense: {
          height: 68,
          minHeight: 68,
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "primary" },
          style: {
            color: "white",
            backgroundColor: "#1b2064",
            padding: '8px 16px',
            height: '40px',
            fontSize: '14px',
            fontWeight: 400,
            cursor: 'pointer !important',
            '&:hover': {
              backgroundColor: "#42478dff",
            },
          },
        },
      ],
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '14px',
        },
      },
    },
  },

  palette: {
    background: {
      default: '#ffffff',
    },
  },
})